/* eslint-disable react/no-danger */
import { useEffect, useRef, useState } from 'react';
import { useIsGlobetrotter } from '@bwoty-web/ui-kit/hooks';
import PropTypes from 'prop-types';
import uniqid from 'uniqid';
import cx from 'classnames';

import './sectionParagraph.scss';

const SectionParagraph = ({ paragraph, readMoreLabel, className }) => {
  const el = useRef(null);
  const isGlobe = useIsGlobetrotter();
  const [truncate, setTruncate] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (
      !truncate &&
      el.current &&
      el.current.scrollHeight > el.current.clientHeight
    ) {
      setTruncate(true);
    }
  }, []);

  if (!paragraph) {
    return null;
  }

  const { heading, content, listItems, paragraphs } = paragraph;

  return (
    <div className={cx('gw-section-paragraph', className)}>
      {heading && <h3 className="gw-section-paragraph-h3">{heading}</h3>}
      {content && (
        <p
          ref={el}
          className={cx('gw-section-paragraph-content', {
            'gw-section-paragraph-content--truncate':
              readMoreLabel && !isGlobe && !expanded,
          })}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
      {readMoreLabel && truncate && !expanded && (
        <button type="button" onClick={() => setExpanded(true)}>
          {readMoreLabel}
        </button>
      )}
      {listItems && !!listItems.length && (
        <ul
          className={cx('gw-section-paragraph__list', {
            'gw-section-paragraph__list--column': listItems.length > 7,
          })}
        >
          {listItems.map((item) => {
            return (
              <li key={uniqid('list-item-')}>
                <span dangerouslySetInnerHTML={{ __html: item.content }} />
              </li>
            );
          })}
        </ul>
      )}
      {paragraphs &&
        paragraphs?.map((subparagraph) => {
          return (
            <SectionParagraph
              className={cx({
                'gw-section-content__paragraph-list': subparagraph?.listItems,
              })}
              paragraph={subparagraph}
              key={uniqid('section-subparagraph-')}
            />
          );
        })}
    </div>
  );
};

SectionParagraph.propTypes = {
  paragraph: PropTypes.shape({
    heading: PropTypes.string,
    content: PropTypes.string,
    listItems: PropTypes.arrayOf(
      PropTypes.shape({
        content: PropTypes.string,
      }),
    ),
    paragraphs: PropTypes.arrayOf({
      paragraph: PropTypes.shape({
        heading: PropTypes.string,
        content: PropTypes.string,
        listItems: PropTypes.arrayOf(
          PropTypes.shape({
            content: PropTypes.string,
          }),
        ),
      }),
    }),
  }).isRequired,
  readMoreLabel: PropTypes.string,
  className: PropTypes.string,
};

SectionParagraph.defaultProps = {
  readMoreLabel: '',
  className: '',
};

export default SectionParagraph;
